import {
   InvoiceForCurrencyForLegalEntity,
   Transaction,
   TransactionPaymentMedia,
   TransactionStatus,
   TransactionType
} from '@ravago/shared/page-data/models/elements';

import { isOverDue } from './invoice-date.utils';

export const canPayInvoiceOnline = (invoice: Transaction) => invoice.paymentMedia === TransactionPaymentMedia.WIRE_TRANSFER;

export const canSelectInvoice = (invoice: Transaction) =>
   canPayInvoiceOnline(invoice) &&
   invoice.type === TransactionType.INVOICE &&
   invoice.status !== TransactionStatus.PAID &&
   invoice.status !== TransactionStatus.PENDING &&
   invoice.status !== TransactionStatus.CLOSED;

export const getInvoicesForLegalEntityAndCurrency = (openInvoices: InvoiceForCurrencyForLegalEntity[], legalEntity: string, currency: string) =>
   openInvoices.find((i) => i.legalEntity === legalEntity)?.currencyTransactions?.find((ct) => ct.currency === currency)?.transactions;

export const getInvoicesForPaymentType = (invoices: Transaction[], selectedInvoiceIds: string[], paymentType: 'selected' | 'open' | 'overdue') => {
   if (paymentType === 'selected') return invoices.filter((invoice) => selectedInvoiceIds.includes(invoice.id));
   if (paymentType === 'open') return invoices.filter(canSelectInvoice);
   return invoices.filter((invoice) => invoice.dueDate && isOverDue(invoice.dueDate) && canSelectInvoice(invoice));
};
